import useHomepage from 'gatsby-theme-homepage/src/hooks/use-homepage';

export default useHomepage;
